/* summary: Class for serving the JS resources for guided tour providers that needs they own JS.
This module is shared between mobile and desktop, and is in charge of lazy loading
the JS resource of the self guided tour provider by looking at a hidden input that will contain
the JS path downloading the resource. That way, after opening a modal a lazy request
will take place for loading the given resource based on the guided tour provider. */
(function guidedTourInitializer(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const guidedTourConfiguration = global.document.querySelector('[data-guided-tour-configuration]');
  const previousGuidedTourInitializer = global.NewHomeSource.GuidedTourInitializer;

  if (!guidedTourConfiguration) {
    return;
  }

  const desktopConfiguration = guidedTourConfiguration.getAttribute('data-desktop-value');
  const mobileConfiguration = guidedTourConfiguration.getAttribute('data-mobile-value');

  /**
  * @private
  * downloadGuidedTourHandler: download the Javascript Handler for the guided tour provider.
  *
  * @param {object} event with the information about the target that the user interacted with.
  */
  function downloadGuidedTourHandler() {
    if (global.define) {
      require([mobileConfiguration], (mobileConfig) => mobileConfig);
    } else {
      const scriptTag = document.createElement('script');
      scriptTag.src = desktopConfiguration;
      scriptTag.type = 'text/javascript';
      scriptTag.async = true;
      document.documentElement.appendChild(scriptTag);
    }
  }

  /**
   * @constructs NewHomeSource.GuidedTourInitializer
   */
  function GuidedTourInitializer() {
    if (document.readyState === 'complete') {
      downloadGuidedTourHandler();
    } else {
      window.addEventListener('load', downloadGuidedTourHandler);
    }
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.NterNowInitializer to the previous script.
   */
  GuidedTourInitializer.noConflict = function noConflict() {
    global.NewHomeSource.GuidedTourInitializer = previousGuidedTourInitializer;
    return GuidedTourInitializer;
  };

  global.NewHomeSource.GuidedTourInitializer = GuidedTourInitializer;
  GuidedTourInitializer();
}(window));
